// Excluir esta bicheira.

import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import ChipInput from 'material-ui-chip-input';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';

import PrincipalMaster from '../master/Principal';
import { pessoaService, nivelAcessoService, Utils } from '../../services';

const DEFAULT_VALUES = {
    dsPessoas: [],
    pessoaSelecionada: { CODIGO: 0 },
    textBuscarPessoa: '',
    dsNiveisAcesso: [],
    niveisAcessoSelecionados: [],
};

class AlterarPessoa extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...DEFAULT_VALUES,
            isPosting: false,
        };
    }

    async buscarPessoas(value) {
        this.setState({ textBuscarPessoa: value });
        const pessoas = await pessoaService.getPessoasByValue(value);
        this.setState({ dsPessoas: pessoas });
    }

    async onGetNiveisAcesso(value) {
        const niveisAcesso = await nivelAcessoService.getNivelAcessoPeloNome(
            value,
        );
        this.setState({
            dsNiveisAcesso: niveisAcesso,
        });
    }

    async onSelectPessoa(pessoa) {
        this._csrf = (await pessoaService.pessoaForm()).token;
        const dadosPessoa = await pessoaService.getPessoa(pessoa.CODIGOCIFRADO);
        this.setState({
            pessoaSelecionada: pessoa,
            niveisAcessoSelecionados: dadosPessoa.niveisAcesso,
        });
    }

    async onSave(event) {
        event.preventDefault();
        const { isPosting, pessoaSelecionada, niveisAcessoSelecionados } =
            this.state;

        if (isPosting) {
            return;
        }

        this.setState({ isPosting: true });
        try {
            let response = await pessoaService.updatePessoaGeral({
                pessoa: pessoaSelecionada,
                niveisAcesso: niveisAcessoSelecionados,
                _csrf: this._csrf,
            });
            Utils.showToast(response.message);
            this.setState(DEFAULT_VALUES);
        } catch (error) {
            Utils.showToast(error.message);
        }
        this.setState({ isPosting: false });
    }

    render() {
        const {
            isPosting,
            dsPessoas,
            pessoaSelecionada,
            dsNiveisAcesso,
            niveisAcessoSelecionados,
            textBuscarPessoa,
        } = this.state;

        return (
            <PrincipalMaster title="Alterar pessoa" {...this.props}>
                <div className="padding-content">
                    <AutoComplete
                        searchText={textBuscarPessoa}
                        fullWidth={true}
                        floatingLabelText="Buscar pessoa"
                        dataSource={dsPessoas}
                        dataSourceConfig={{ text: 'NOME', value: 'CODIGO' }}
                        onUpdateInput={(value) => this.buscarPessoas(value)}
                        onNewRequest={(pessoa) => this.onSelectPessoa(pessoa)}
                        filter={AutoComplete.noFilter}
                    />
                    <br />
                    {pessoaSelecionada.CODIGO !== 0 && (
                        <div>
                            <br />
                            <form onSubmit={(e) => this.onSave(e)}>
                                <Card>
                                    <CardHeader
                                        title={`Informaçoes de ${pessoaSelecionada.NOME}`}
                                    />
                                    <CardText>
                                        <ChipInput
                                            value={niveisAcessoSelecionados}
                                            newChipKeyCodes={[]}
                                            fullWidth={true}
                                            floatingLabelText="Níveis de acesso"
                                            onUpdateInput={(value) =>
                                                this.onGetNiveisAcesso(value)
                                            }
                                            dataSourceConfig={{
                                                text: 'NOME',
                                                value: 'CODIGO',
                                            }}
                                            dataSource={dsNiveisAcesso}
                                            onRequestDelete={(value) =>
                                                this.setState({
                                                    niveisAcessoSelecionados:
                                                        niveisAcessoSelecionados.filter(
                                                            (x) =>
                                                                x.CODIGO !==
                                                                value,
                                                        ),
                                                })
                                            }
                                            onRequestAdd={(nivelAcesso) =>
                                                this.setState({
                                                    niveisAcessoSelecionados:
                                                        niveisAcessoSelecionados.concat(
                                                            nivelAcesso,
                                                        ),
                                                })
                                            }
                                        />
                                    </CardText>
                                    <CardActions>
                                        <RaisedButton
                                            disabled={isPosting}
                                            type="submit"
                                            label="Salvar"
                                            primary={true}
                                        />
                                        <RaisedButton
                                            label="Cancelar"
                                            onClick={() =>
                                                this.setState(DEFAULT_VALUES)
                                            }
                                        />
                                    </CardActions>
                                </Card>
                            </form>
                        </div>
                    )}
                </div>
            </PrincipalMaster>
        );
    }
}

export default AlterarPessoa;
